"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEligibilityTestMiscAvailableFieldProposals = exports.createEligibilityEvaluator = exports.checkEligibilityConfigErrors = exports.EligibilityTestMiscAvailableFields = exports.EligibilityTestMiscAvailableFieldConfigs = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const formula_engine_1 = require("@finley-technologies/formula-engine");
const RequiredIntermediateFields_1 = require("./RequiredIntermediateFields");
exports.EligibilityTestMiscAvailableFieldConfigs = {
    'loanTapeMetadata.reportingDate': {
        label: 'loanTapeMetadata.reportingDate',
        description: 'Loan tape reporting date (loan tape metadata)',
    },
};
exports.EligibilityTestMiscAvailableFields = Object.keys(exports.EligibilityTestMiscAvailableFieldConfigs);
/**
 * Eligibility formulas can use variables from baseFields and intermediate calcs.
 * This functions checks for any missing dependencies found in eligibility formulas.
 */
const checkEligibilityConfigErrors = ({ eligibilityCalcs, intermediateCalcs, baseFields, }) => {
    const dynamicIntermediateFields = intermediateCalcs
        .map((intermediateCalc) => intermediateCalc.field)
        .filter((field) => !RequiredIntermediateFields_1.RequiredIntermediateFieldNames.includes(field));
    const baseFieldVars = baseFields.map((fieldConfig) => `baseFields.${fieldConfig.field}`);
    const dynamicFieldVars = dynamicIntermediateFields.map((key) => `dynamicIntermediateFields.${key}`);
    const requiredFieldVars = RequiredIntermediateFields_1.RequiredIntermediateFieldNames.map((key) => `requiredIntermediateFields.${key}`);
    const loanTapeMetaDataVars = ['loanTapeMetadata.reportingDate'];
    const availableVariables = new Set([
        ...baseFieldVars,
        ...dynamicFieldVars,
        ...requiredFieldVars,
        ...loanTapeMetaDataVars,
    ]);
    // generate formula dependencies for each field
    const errorsPerField = eligibilityCalcs.map((eligibility) => {
        (0, common_1.finleyAssert)(eligibility.type === 'formula', 'eligibility calc only support formulas');
        const formulaErrors = (0, formula_engine_1.getFormulaErrors)(eligibility.config.formula, availableVariables);
        return {
            propertyKey: eligibility.propertyKey,
            ...formulaErrors,
        };
    });
    // filter out things that are not really missing.
    const definitelyMissing = errorsPerField.filter(({ errorMessages }) => errorMessages.length > 0);
    return definitelyMissing;
};
exports.checkEligibilityConfigErrors = checkEligibilityConfigErrors;
const createEligibilityEvaluator = (eligibilityConfigs, f1EngineMode) => {
    // extract formulas from the config.
    // instantiate FormulaEngine with all formula strings
    // we need to do this upfront to ensure that formula's AST are cached.
    const formulaStrings = eligibilityConfigs
        .filter((config) => config.type === 'formula')
        .map((config) => {
        (0, common_1.finleyAssert)(config.type === 'formula', 'keep TS happy');
        (0, common_1.finleyAssert)(config.config.engineVersion ===
            finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1, `${config.config.engineVersion} is not yet supported`);
        return config.config.formula;
    });
    const formulaEngine = (0, formula_engine_1.createFormulaEngine)(finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1, formulaStrings, f1EngineMode);
    const setVariables = (inputFields) => {
        formulaEngine.setVariables(inputFields, { flatten: true });
    };
    const evaluateConfig = (config, waiveConfig) => {
        (0, common_1.finleyAssert)(config.type === 'formula', `${config.type} is not yet supported`);
        (0, common_1.finleyAssert)(config.config.engineVersion ===
            finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1, `${config.config.engineVersion} is not yet supported`);
        const isEligible = formulaEngine.evaluateBoolean(config.config.formula);
        const areAllEligibilityKeysWaivedForReceivable = waiveConfig.waiveAllEligibility;
        const isSpecificEligibilityKeyWaivedForReceivable = waiveConfig.waivedEligibilityTestKeysForReceivable.has(config.propertyKey);
        const isWaived = areAllEligibilityKeysWaivedForReceivable ||
            isSpecificEligibilityKeyWaivedForReceivable;
        if (isEligible) {
            return 'ELIGIBLE';
        }
        if (isWaived) {
            return 'INELIGIBLE_WAIVED';
        }
        return 'INELIGIBLE';
    };
    return {
        evaluateConfig,
        setVariables,
    };
};
exports.createEligibilityEvaluator = createEligibilityEvaluator;
const createEligibilityTestMiscAvailableFieldProposals = () => {
    return _.map(exports.EligibilityTestMiscAvailableFieldConfigs, ({ label, description }) => ({
        label,
        documentation: description,
        insertText: label,
    }));
};
exports.createEligibilityTestMiscAvailableFieldProposals = createEligibilityTestMiscAvailableFieldProposals;
//# sourceMappingURL=eligibilityEvaluator.js.map